import { LanguageCode } from "./languages/LanguageTypes";
import { DE_LANGUAGE } from "./languages/DeLanguage";
import { EN_LANGUAGE } from "./languages/EnLanguage";
import { getQueryParameter, isString } from "flavr-common";
const DEFAULT_LANGUAGE_CODE = LanguageCode.en;
class LocalizationService {
    constructor() {
        this.localizations = new Map();
        this.currentLanguageCode = this.getBrowserLanguageCode();
        this.currentTranslations = new Map();
        const lang = getQueryParameter(location.search, "lang");
        if (lang) {
            if (this.isLanguageCodeValid(lang)) {
                this.setCurrentLanguage(lang);
            }
            else {
                console.warn(`lang=${String(lang)} is not valid`);
            }
        }
        this.addLocalization(LanguageCode.de, DE_LANGUAGE);
        this.addLocalization(LanguageCode.en, EN_LANGUAGE);
        this.loadTranslation();
    }
    getBrowserLanguageCode() {
        const lang = navigator.language;
        const matchArray = lang.match(/^\w*/i);
        let code = DEFAULT_LANGUAGE_CODE;
        if (matchArray && matchArray.length) {
            const codeStr = matchArray[0].toLowerCase();
            if (this.isLanguageCodeValid(codeStr)) {
                code = codeStr;
            }
        }
        return code;
    }
    setCurrentLanguage(code) {
        this.currentLanguageCode = code;
    }
    getTranslation(localization) {
        if (isString(localization)) {
            return localization;
        }
        let translation = this.currentTranslations.get(localization.key);
        if (!translation) {
            return localization.key;
        }
        if (localization.params) {
            translation = this.applyLocalizationParams(translation, localization.params);
        }
        return translation;
    }
    applyLocalizationParams(translation, params) {
        for (const key in params) {
            const paramValue = params[key];
            const pattern = `{${key}}`;
            translation = translation.replace(new RegExp(pattern, "g"), paramValue);
        }
        return translation;
    }
    addLocalization(code, loc) {
        let locations = this.localizations.get(code);
        if (!locations) {
            this.localizations.set(code, (locations = []));
        }
        locations.push(loc);
    }
    loadTranslation() {
        const locations = this.localizations.get(this.currentLanguageCode);
        if (!locations) {
            throw new Error(`Can't find location for ${this.currentLanguageCode} language code`);
        }
        for (const location of locations) {
            for (const key in location) {
                const text = location[key];
                this.currentTranslations.set(key, text);
            }
        }
    }
    isLanguageCodeValid(code) {
        return code in LanguageCode;
    }
}
export const localizationService = new LocalizationService();
